import { defineMessages } from 'react-intl';

/** The texts of the row "Spotify Canvas" of "Where it plays" (design spotify-canvas a2, a3). */
export const spotifyCanvasMessages = defineMessages({
  /** The label of the box in the Spotify row (design spotify-canvas d3). */
  extrasLabel: { id: 'app.sml.servicesPanel.spotifyExtras.label', defaultMessage: 'Spotify extras' },
  /** The name of the Canvas line in "Spotify extras" (design d3). */
  title: { id: 'app.sml.servicesPanel.canvas.title', defaultMessage: 'Canvas' },
  // Chips (design spotify-canvas a2).
  chipOnSpotify: { id: 'app.sml.servicesPanel.canvas.chip.onSpotify', defaultMessage: 'On Spotify' },
  chipMaking: { id: 'app.sml.servicesPanel.canvas.chip.making', defaultMessage: 'Making' },
  chipUploading: { id: 'app.sml.servicesPanel.canvas.chip.uploading', defaultMessage: 'Uploading' },
  chipWaits: { id: 'app.sml.servicesPanel.canvas.chip.waits', defaultMessage: 'Waits' },
  chipFailed: { id: 'app.sml.servicesPanel.canvas.chip.failed', defaultMessage: 'Failed' },
  chipSignedOut: { id: 'app.sml.servicesPanel.canvas.chip.signedOut', defaultMessage: 'Signed out' },
  chipInReview: { id: 'app.sml.servicesPanel.canvas.chip.inReview', defaultMessage: 'In review' },
  chipHasCanvas: { id: 'app.sml.servicesPanel.canvas.chip.hasCanvas', defaultMessage: 'Has a Canvas' },
  chipAuto: { id: 'app.sml.servicesPanel.canvas.chip.auto', defaultMessage: 'Auto' },
  chipWatermark: { id: 'app.sml.servicesPanel.canvas.chip.watermark', defaultMessage: 'Watermark' },
  // Sentences of the states (design spotify-canvas a2).
  notConnected: {
    id: 'app.sml.servicesPanel.canvas.notConnected',
    defaultMessage: 'Connect Spotify for Artists. MUSIC24 then sends the Canvas loop of this song to Spotify.',
  },
  reconnect: {
    id: 'app.sml.servicesPanel.canvas.reconnect',
    defaultMessage: 'The Spotify for Artists login stopped working. Reconnect it, then upload.',
  },
  noCanvas: {
    id: 'app.sml.servicesPanel.canvas.noCanvas',
    defaultMessage: 'The Release Kit of this song has no Canvas loop yet.',
  },
  rendering: {
    id: 'app.sml.servicesPanel.canvas.rendering',
    defaultMessage: 'MUSIC24 makes the Canvas loop. It takes about 1 minute.',
  },
  noTrack: {
    id: 'app.sml.servicesPanel.canvas.noTrack',
    defaultMessage: 'Add the Spotify link of this song first. MUSIC24 needs it to find the track.',
  },
  notLiveAuto: {
    id: 'app.sml.servicesPanel.canvas.notLiveAuto',
    defaultMessage: 'Goes to Spotify when the song is live.',
  },
  notLive: {
    id: 'app.sml.servicesPanel.canvas.notLive',
    defaultMessage: 'Not live on Spotify yet. Spotify takes a Canvas only for a live song.',
  },
  ready: {
    id: 'app.sml.servicesPanel.canvas.ready',
    defaultMessage: 'Ready to go: a Canvas loop of this song, 9:16, MP4.',
  },
  watermark: {
    id: 'app.sml.servicesPanel.canvas.watermark',
    defaultMessage: 'Free plan: the loop carries the "Made with MUSIC24" mark.',
  },
  uploading: {
    id: 'app.sml.servicesPanel.canvas.uploading',
    defaultMessage: 'MUSIC24 sends the Canvas. Spotify then processes the file.',
  },
  inReview: {
    id: 'app.sml.servicesPanel.canvas.inReview',
    defaultMessage: 'Spotify reviews the Canvas. It shows in the app after the review.',
  },
  onSpotify: {
    id: 'app.sml.servicesPanel.canvas.onSpotify',
    defaultMessage: 'Sent on {date}. Fans see it in the Spotify app.',
  },
  onSpotifyAuto: {
    id: 'app.sml.servicesPanel.canvas.onSpotifyAuto',
    defaultMessage: 'Sent by auto upload on {date}.',
  },
  onSpotifyVersion: {
    id: 'app.sml.servicesPanel.canvas.onSpotifyVersion',
    defaultMessage: 'Version {revision} is on Spotify since {date}.',
  },
  newer: { id: 'app.sml.servicesPanel.canvas.newer', defaultMessage: 'A newer Canvas is ready.' },
  // Fail reasons (design spotify-canvas a3).
  failReconnect: {
    id: 'app.sml.servicesPanel.canvas.fail.reconnect',
    defaultMessage: 'Spotify refused the login. Reconnect Spotify for Artists, then try again.',
  },
  failNoPermission: {
    id: 'app.sml.servicesPanel.canvas.fail.noPermission',
    defaultMessage:
      "Your Spotify for Artists login cannot edit this track's Canvas. Ask an admin of the artist in Spotify for Artists for the Editor role.",
  },
  failNotLive: {
    id: 'app.sml.servicesPanel.canvas.fail.notLive',
    defaultMessage: 'Spotify does not show this song as live yet. Try again when it is out.',
  },
  failFile: {
    id: 'app.sml.servicesPanel.canvas.fail.file',
    defaultMessage: 'Spotify does not take this file: {rule}',
  },
  failFileNoRule: {
    id: 'app.sml.servicesPanel.canvas.fail.fileNoRule',
    defaultMessage: 'Spotify does not take this file.',
  },
  failRefused: {
    id: 'app.sml.servicesPanel.canvas.fail.refused',
    defaultMessage: 'Spotify refused the upload: "{detail}".',
  },
  failRefusedNoDetail: {
    id: 'app.sml.servicesPanel.canvas.fail.refusedNoDetail',
    defaultMessage: 'Spotify refused the upload.',
  },
  failRejected: {
    id: 'app.sml.servicesPanel.canvas.fail.rejected',
    defaultMessage: 'Spotify did not accept the Canvas after its review.',
  },
  failFileGone: {
    id: 'app.sml.servicesPanel.canvas.fail.fileGone',
    defaultMessage: 'The Canvas file is no longer in the Release Kit.',
  },
  failError: { id: 'app.sml.servicesPanel.canvas.fail.error', defaultMessage: 'The upload did not finish.' },
  existingCanvas: {
    id: 'app.sml.servicesPanel.canvas.existingCanvas',
    defaultMessage: 'This song has a Canvas that you set in Spotify for Artists. MUSIC24 did not replace it.',
  },
  // The file rules of `failDetail` (design spotify-canvas a3 note).
  ruleType: { id: 'app.sml.servicesPanel.canvas.rule.type', defaultMessage: 'it is not an MP4 file.' },
  ruleSize: { id: 'app.sml.servicesPanel.canvas.rule.size', defaultMessage: 'it is larger than 8 MB.' },
  ruleTooShort: { id: 'app.sml.servicesPanel.canvas.rule.tooShort', defaultMessage: 'it is shorter than 3 seconds.' },
  ruleTooLong: { id: 'app.sml.servicesPanel.canvas.rule.tooLong', defaultMessage: 'it is longer than 8 seconds.' },
  ruleAspect: { id: 'app.sml.servicesPanel.canvas.rule.aspect', defaultMessage: 'it is not 9:16.' },
  ruleTooSmall: { id: 'app.sml.servicesPanel.canvas.rule.tooSmall', defaultMessage: 'it is less than 720 px high.' },
  // Actions (design spotify-canvas a2, a3).
  actionConnect: { id: 'app.sml.servicesPanel.canvas.action.connect', defaultMessage: 'Connect Spotify for Artists' },
  actionReconnect: { id: 'app.sml.servicesPanel.canvas.action.reconnect', defaultMessage: 'Reconnect' },
  actionMakeCanvas: {
    id: 'app.sml.servicesPanel.canvas.action.makeCanvas',
    defaultMessage: 'Make a Canvas in the Studio',
  },
  actionMakeNewCanvas: { id: 'app.sml.servicesPanel.canvas.action.makeNewCanvas', defaultMessage: 'Make a new Canvas' },
  actionUpload: { id: 'app.sml.servicesPanel.canvas.action.upload', defaultMessage: 'Upload to Spotify' },
  actionUploadIt: { id: 'app.sml.servicesPanel.canvas.action.uploadIt', defaultMessage: 'Upload it' },
  actionRetry: { id: 'app.sml.servicesPanel.canvas.action.retry', defaultMessage: 'Try again' },
  actionReplace: { id: 'app.sml.servicesPanel.canvas.action.replace', defaultMessage: 'Replace it' },
  actionOpen: { id: 'app.sml.servicesPanel.canvas.action.open', defaultMessage: 'Open on Spotify' },
  autoUploadTitle: { id: 'app.sml.servicesPanel.canvas.autoUploadLink', defaultMessage: 'Auto upload' },
  /** Any other refused POST or PUT (design spotify-canvas a2 note, b2). */
  didNotWork: { id: 'app.sml.servicesPanel.canvas.didNotWork', defaultMessage: 'That did not work. Try again.' },
});

/** The texts of the auto upload switch and the terms dialog (design spotify-canvas b1-b5). */
export const spotifyCanvasSwitchMessages = defineMessages({
  label: {
    id: 'app.sml.servicesPanel.canvas.switch.label',
    defaultMessage: 'Upload Canvas to Spotify automatically',
  },
  forArtist: { id: 'app.sml.servicesPanel.canvas.switch.forArtist', defaultMessage: 'For every song of {artist}' },
  /** The text of the terms dialog from the switch (design spotify-canvas b3). */
  explanation: {
    id: 'app.sml.servicesPanel.canvas.switch.explanation',
    defaultMessage:
      'MUSIC24 sends the Canvas of each song when the song is live on Spotify and its Canvas is ready, and sends it again after you redo the kit.',
  },
  /** The line under "Auto upload" in "Spotify extras" (design spotify-canvas d3). */
  onFor: { id: 'app.sml.servicesPanel.canvas.switch.onFor', defaultMessage: 'On for every song of {artist}' },
  off: {
    id: 'app.sml.servicesPanel.canvas.switch.off',
    defaultMessage: 'Off. Turn it on to send the Canvas of each live song.',
  },
  termsAcceptedCanvas: {
    id: 'app.sml.servicesPanel.canvas.switch.termsAcceptedCanvas',
    defaultMessage: 'Spotify Canvas terms accepted on {date}',
  },
  termsAccepted: {
    id: 'app.sml.servicesPanel.canvas.switch.termsAccepted',
    defaultMessage: 'Terms accepted on {date}',
  },
  demo: { id: 'app.sml.servicesPanel.canvas.switch.demo', defaultMessage: 'The demo artist is read only.' },
  // The box on the Spotify for Artists card of Catalog (design spotify-canvas b5).
  cardNote: {
    id: 'app.sml.servicesPanel.canvas.switch.cardNote',
    defaultMessage: 'MUSIC24 can send the Canvas of your songs.',
  },
  cardOff: {
    id: 'app.sml.servicesPanel.canvas.switch.cardOff',
    defaultMessage: 'Off. MUSIC24 sends a Canvas only when you click Upload.',
  },
  cardSignedOut: {
    id: 'app.sml.servicesPanel.canvas.switch.cardSignedOut',
    defaultMessage: 'On. Uploads wait until you reconnect.',
  },
  // The terms dialog (design spotify-canvas b3, b4).
  termsTitle: { id: 'app.sml.servicesPanel.canvas.terms.title', defaultMessage: 'Spotify Canvas terms' },
  termsSub: {
    id: 'app.sml.servicesPanel.canvas.terms.sub',
    defaultMessage: 'Accept one time for {artist}. MUSIC24 keeps the date.',
  },
  termsLabel: { id: 'app.sml.servicesPanel.canvas.terms.label', defaultMessage: 'Spotify asks you to accept this' },
  termsAccept: { id: 'app.sml.servicesPanel.canvas.terms.accept', defaultMessage: 'I accept' },
  termsLink: { id: 'app.sml.servicesPanel.canvas.terms.link', defaultMessage: 'Spotify for Artists Terms' },
  termsWhatUpload: {
    id: 'app.sml.servicesPanel.canvas.terms.whatUpload',
    defaultMessage: 'MUSIC24 sends the Canvas loop of {title} to Spotify now.',
  },
  termsTurnOn: { id: 'app.sml.servicesPanel.canvas.terms.turnOn', defaultMessage: 'Accept and turn on' },
  termsUpload: { id: 'app.sml.servicesPanel.canvas.terms.upload', defaultMessage: 'Accept and upload' },
});
